/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ brand: NonNullable<unknown> }} Public_Site_Hero_TitleInputs */

const cs_public_site_hero_title = /** @type {(inputs: Public_Site_Hero_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nemovitosti od ${i?.brand}`)
};

const en_public_site_hero_title = /** @type {(inputs: Public_Site_Hero_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Properties by ${i?.brand}`)
};

/**
* | output |
* | --- |
* | "Properties by {brand}" |
*
* @param {Public_Site_Hero_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const public_site_hero_title = /** @type {((inputs: Public_Site_Hero_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Public_Site_Hero_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_public_site_hero_title(inputs)
	return cs_public_site_hero_title(inputs)
});